import { io } from "socket.io-client";

const API_URL = process.env.REACT_APP_HUB_API_URL || "http://localhost:4100";

let socket = null;

/*
 * Credencial do painel para o handshake (P0-A): a MESMA que a API usa (hubApi.js), na mesma
 * ordem, enviada em `auth` — nunca na query string. A sala e decidida pelo servidor a partir
 * dela; o painel nao informa mais o tenant.
 *
 * `auth` como funcao: cada (re)conexao le a credencial atual do localStorage (login novo,
 * token renovado).
 */
function credencialDoPainel() {
  const apiKey = localStorage.getItem("hub_api_key");
  const token = localStorage.getItem("hub_token");
  if (apiKey) return { apiKey };
  if (token) return { token };
  return {};
}

export function connectSocket() {
  if (socket) {
    if (socket.connected) return socket;
    socket.disconnect();
    socket = null;
  }

  socket = io(API_URL, {
    auth: (cb) => cb(credencialDoPainel()),
    transports: ["websocket", "polling"],
  });

  socket.on("connect", () => {
    console.log("[Hub:Socket] Connected:", socket.id);
  });

  // Handshake recusado (sem credencial, expirada, usuario inativo...): o servidor nao diz o motivo.
  socket.on("connect_error", (err) => {
    console.warn("[Hub:Socket] Conexao em tempo real recusada:", err && err.message);
  });

  // Sessao encerrada pelo servidor (token expirou, usuario desativado, chave trocada).
  socket.on("auth:encerrada", (data) => {
    console.warn("[Hub:Socket] Sessao em tempo real encerrada:", data && data.motivo);
  });

  socket.on("disconnect", () => {
    console.log("[Hub:Socket] Disconnected");
  });

  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
